import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DELETE_ORGANIZATION_OR_BUILDING } from "./url-constants";

type DeleteOrganizationOrBuildingEndpointSpecifications = ApiEndpointSpecification;

export const DeleteOrganizationOrBuildingEndpointSpecification: DeleteOrganizationOrBuildingEndpointSpecifications = {
    url: DELETE_ORGANIZATION_OR_BUILDING,
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'DeleteOrganizationOrBuildingRequestParams',
    requestBodySchemaName: 'DeleteOrganizationOrBuildingRequestBody',
    okResponseSchemaName: 'DeleteOrganizationOrBuildingOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: false,
}

export const invokeDeleteOrganizationOrBuilding = Helpers.makeActualApiRequestFn<
    Types.DeleteOrganizationOrBuildingRequestParams,
    Types.DeleteOrganizationOrBuildingRequestBody,
    Types.DeleteOrganizationOrBuildingOkResponse
>(DeleteOrganizationOrBuildingEndpointSpecification); 